if (!customElements.get('pdp-tabs')) {
  customElements.define('pdp-tabs', class PdpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pdp-tabs__tab'));
      this.indicator = this.querySelector('.pdp-tabs__indicator');
      this.panels = Array.from(this.querySelectorAll('.pdp-tabs__panel'));

      if (this.tabs.length === 0) return;

      // The "tabs under gallery" setting relocates this element between slots,
      // which re-runs connectedCallback. Only bind listeners once.
      if (this.initialized) {
        this.observeResize();
        const current = this.querySelector('.pdp-tabs__tab.is-active');
        if (current) this.updateIndicator(current, true);
        return;
      }

      this.init();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    init() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(tab));
        tab.addEventListener('keydown', (e) => this.handleKeyDown(e, index));
      });

      const activeTab = this.querySelector('.pdp-tabs__tab.is-active') || this.tabs[0];
      if (activeTab) {
        this.updateIndicator(activeTab, true);
      }

      this.observeResize();
      this.initialized = true;
    }

    observeResize() {
      if (!('ResizeObserver' in window) || this.resizeObserver) return;
      this.resizeObserver = new ResizeObserver(() => {
        const currentActive = this.querySelector('.pdp-tabs__tab.is-active');
        if (currentActive) this.updateIndicator(currentActive, true);
      });
      this.resizeObserver.observe(this);
    }

    updateIndicator(activeTab, immediate = false) {
      if (!activeTab || !this.indicator) return;

      const width = activeTab.offsetWidth;
      const left = activeTab.offsetLeft;

      if (immediate) {
        this.indicator.style.transition = 'none';
      } else {
        this.indicator.style.transition = '';
      }

      this.indicator.style.width = width + 'px';
      this.indicator.style.transform = 'translateX(' + left + 'px)';

      if (immediate) {
        void this.indicator.offsetWidth;
        this.indicator.style.transition = '';
      }
    }

    switchTab(clickedTab) {
      if (clickedTab.classList.contains('is-active')) return;

      const targetPanelId = clickedTab.getAttribute('aria-controls');

      this.tabs.forEach(tab => {
        const isActive = tab === clickedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.updateIndicator(clickedTab, false);

      this.panels.forEach(panel => {
        if (panel.id === targetPanelId) {
          panel.removeAttribute('hidden');
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        }
      });
    }

    handleKeyDown(e, index) {
      if (e.key === 'ArrowRight') {
        const next = this.tabs[(index + 1) % this.tabs.length];
        next.focus();
        this.switchTab(next);
      } else if (e.key === 'ArrowLeft') {
        const prev = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        prev.focus();
        this.switchTab(prev);
      }
    }
  });
}
